module.exports = __webpack_public_path__ + "bigquery.07d56292.svg";


//////////////////
// WEBPACK FOOTER
// ./src/db/img/bigquery.svg
// module id = Ybn1
// module chunks = 1